import React, {useMemo} from "react";
import {FormattedMessage} from "react-intl";
import Currency from "../../../Currency/Currency";

import './UserParlayFooter.style.scss';
import {ParlayStatus, PayoutModel} from "../../../../constants/PickXEnums";
import {useNavigate} from "react-router-dom";
import {useGetRollingPrizeQuery} from "../../../../stores/pickX/pickX.api";
import PayoutInfoPopUp from "../../../../views/PopUps/PayoutInfoPopUp/PayoutInfoPopUp";
import useAppModalService from "../../../../hooks/useAppModalService";


const tKey = "lobbyView.contests.prePackageContest.prePackageContestCard"
const UserParlayFooter = ({parlay, contests, prizeAsset}) => {
    const {openModal} = useAppModalService();

    let sportId = parlay.SportIds?.[0];
    if(!sportId && contests.length > 0)
        sportId = contests[0]?.SportId;

    const payoutInfos = parlay.getPayouts(contests, prizeAsset);
    const lastTwoPayoutInfos = payoutInfos.slice(-2);
    const lastOnePayOutInfos = payoutInfos.slice(-1);

    const lastPayoutInfo = parlay.PayoutModel === PayoutModel.Flex ? lastTwoPayoutInfos : lastOnePayOutInfos;
    const selectedContestType = parlay.payoutModelStr.toLowerCase();

    const handleViewPayout = async (e) => {
        try {
            await openModal('payoutInfoPopUp', 'info', {
                details: 'Some details about Payout Info',
                modalComponent: PayoutInfoPopUp,
                onOk: () => console.log('OK clicked'),
                onCancel: () => console.log('Cancel clicked'),
                onClose: () => console.log('Close clicked'),
            }, {
                payoutInfos,
                currency: parlay.WagerCurrency
            });
        } catch (error) {
            console.error('Error opening modal:', error);
        }
    }


    return <div className="UserParlayFooter">
        <div className="userParlayFooterContent">
            <div className="entryFee">
                <FormattedMessage id={`${tKey}.entryFee`}/> <Currency currency={parlay?.WagerCurrency}
                                                                      value={parlay?.Wager || 0} removeDecimal/>
            </div>
            {(parlay?.PayoutModel === PayoutModel.Flex ||
                parlay?.PayoutModel === PayoutModel.Exact) &&
                <div className="modeSelector">
                    <div className={`modeButton ${selectedContestType === 'flex' ? 'selected gold-background' : ''}`}>
                        FLEX
                    </div>
                    <div className={`modeButton ${selectedContestType === 'exact' ? 'selected gold-background' : ''}`}>
                        EXACT
                    </div>
                </div>}
            {(parlay?.PayoutModel === PayoutModel.Pick12 ||
                parlay?.PayoutModel === PayoutModel.Pick16) ?
                lastPayoutInfo[0]?.payout && <div className="grandPrize">
                    <span className="grandPrizeText gold-gradient-text">Grand Prize </span><span
                    className="grandPrizePayout"><Currency
                    currency={parlay.WagerCurrency}
                    value={lastPayoutInfo[0].payout || 0}
                    className="gold-gradient-text"
                    removeDecimal={true}/></span>
                </div>
                :
                <table className="payoutInfoTable">
                    <tbody>
                    {lastPayoutInfo?.map((payout, index) => (
                        <tr key={index}>
                            <td className={"correct"}>{payout.correct}/{payout.total} <FormattedMessage
                                id="lobbyView.contests.customContest.customParlayTable.correct"/></td>
                            <td className="multiplier gold-gradient-border">
                                <div
                                    className={`${payout.multiplier.toFixed(0) > 100 ? 'largeNum' : ''} gold-gradient-text`}>x{(payout.multiplier > 100 ? Math.round(payout.multiplier)
                                                                                                                                                        : payout.multiplier.toFixed(1).replace(/\.?0+$/, ''))}</div>
                            </td>
                            <td className={"payout"}>
                            <span>
                                <FormattedMessage
                                    id="lobbyView.contests.customContest.customParlayTable.payout"/> <Currency
                                currency={parlay.WagerCurrency}
                                value={payout.payout || 0}
                                className="gold-gradient-text"
                                removeDecimal={true}
                            />
                            </span>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>}

            {(parlay?.PayoutModel === PayoutModel.Pick12 ||
                    parlay?.PayoutModel === PayoutModel.Pick16) &&
                <div className="fullPayoutButton gold-background"
                     onClick={() => handleViewPayout()}>
                    <FormattedMessage id={`${tKey}.fullPayout`}/>
                </div>}
        </div>
    </div>
}

export default UserParlayFooter